<template>
    <v-container fluid class="white elevation-4 pt-0">
        <main-app-bar :title="$router.currentRoute.meta.title">
            <template v-slot:buttons>
                <v-menu
                  v-model="monthMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  hide-details
                >
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="month"
                          class="monthField"
                          label="Month"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details
                          :disabled="loading"
                      />
                  </template>
                  <v-date-picker
                      type="month"
                      v-model="month"
                      no-title
                      :max="maxDate"
                      @input="monthMenu = false"
                      @change="reloadData"
                  />
                </v-menu>
                <v-btn class="mx-4" @click="cancelBudgetEdit">Cancel</v-btn>
                <v-btn color="primary" :loading="sendRequestLoading" :disabled="isMassUpdate" @click="sendForm">Save
                </v-btn>
            </template>
        </main-app-bar>
        <v-flex class="text-center">
            <v-progress-circular
                class="mt-5"
                indeterminate
                color="green"
                v-if="loading"
            ></v-progress-circular>
        </v-flex>
        <v-data-table
            :hide-default-header="true"
            :hide-default-footer="true"
            item-key="name"
            show-expand
            fixed-header
            height="calc(100vh - 100px)"
            dense
            class="elevation-0 table-bordered pt-5"
            v-if="!tokenMissed && !loading"
        >
            <template v-slot:header>
                <thead>
                <tr>
                    <th rowspan="2" class="text-center font-weight-bold body-2 sticky-column sticky-column-header">
                    </th>
                    <th v-if="isMassUpdate" class="text-center font-weight-bold body-2">{{ massUpdateAllowPercentage()
                        }}%
                    </th>
                    <th v-for="(clinic, index) in headers" :key="index">
                        <div class="text-center body-2 text-uppercase font-weight-bold custom-years-title">
                            {{clinic.title}}
                        </div>
                        <div v-if="isMassUpdate" class="d-flex justify-center align-center" style="margin-top: -10px">
                            <v-checkbox multiple v-model="massUpdateForm.clinics" :value="clinic.id"></v-checkbox>
                        </div>
                        <!-- <div v-else class="percentage-left">{{ percentageLeftValue(clinic.id) }}%</div> -->
                    </th>
                </tr>
                </thead>
            </template>
            <template v-slot:body>
                <tbody>
                <template v-for="(category, index) in tableData">
                    <tr :key="index">
                        <td class="sticky-column">
                          <span class="d-flex justify-space-between align-center ">
                            {{ category.title }}
                          </span>
                        </td>
                        <td v-if="isMassUpdate">
                            <v-text-field filled v-if="isMassUpdate" dense outlined class="inputMassUpdate"
                                          @change="massUpdatePercentageHandler($event, category.title)"></v-text-field>
                        </td>
                        <template v-for="clinic in category.clinics">
                            <td :key="index + 'clinic' + clinic.id" style="text-align: center;">
                                <v-form v-if="clinic.editor" class="d-flex justify-center">
                                    <v-text-field :rules="budgetRules" class="inputInsideTable"
                                                  v-model='inputFormData.percentage'
                                                  placeholder="Set percentage"></v-text-field>
                                    <v-btn @click="percentageHandler">Set</v-btn>
                                </v-form>
                                <p class="mb-0" v-else @click="editorHandler(true, category, clinic)">{{
                                    clinic.percentage }}</p>
                            </td>
                        </template>
                    </tr>
                </template>
                </tbody>
            </template>
        </v-data-table>
        <v-flex class="d-flex align-center" v-if="!loading && !tokenMissed">
            <v-switch v-model="isMassUpdate" class="pt-5 mr-5" label="Mass update"></v-switch>
            <v-btn class="mx-4" color="warning" v-if="isMassUpdate" @click="saveMassUpdate">Apply</v-btn>
        </v-flex>
        <div class="text-center" v-if="tokenMissed">
            <h1>Something wrong with your Xero access</h1>
            <v-btn
                class="mt-5"
                :href="xeroLoginHref"
            >Login</v-btn>
        </div>
    </v-container>
</template>

<script>
  import MainAppBar from '@/components/MainAppBar'
  import config from '@/common/config'
  import moment from 'moment'

  export default {
    components: {
      MainAppBar
    },
    data: () => ({
      tableData: null,
      tokenMissed: false,
      isMassUpdate: false,
      headers: [],
      inputFormData: {
        percentage: null, // input form
        clinicId: null, // input form clinic id
        category: '',
        isOpen: false
      },
      loading: false,
      touched: false,
      month: `${new Date().getFullYear()}-${('0' + (new Date().getMonth() + 1)).slice(-2)}`,
      monthMenu: false,
      sendRequestLoading: false,
      maxDate: moment().format('YYYY-MM'),
      massUpdateForm: {
        clinics: null,
        categories: []
      }
    }),
    computed: {
      budgetRules () {
        return [
          val => !!val || 'Value is required!',
          val => {
            if ((typeof val === 'string' && Number(val.trim())) ||
              (typeof val === 'number') ||
              (typeof val === 'string' && val.trim().length && Number(val.trim()) === 0)) {
              return true
            } else {
              return 'Must be a number'
            }
          }
        ]
      },
      xeroLoginHref () {
        return config.apiUrl + 'xero/login'
      }
    },
    watch: {
      isMassUpdate: function () {
        this.massUpdateForm.clinics = null
        this.massUpdateForm.categories = []
        this.closeEditors()
      }
    },
    methods: {
      closeEditors: function () {
        this.tableData.forEach(({ clinics }) => {
          clinics.forEach(clinic => {
            clinic.editor = false
          })
        })
      },
      massUpdatePercentageHandler: function (value, category) {
        this.touched = true
        const addedCategory = this.massUpdateForm.categories.find(item => item.category === category)
        if (addedCategory) {
          addedCategory.value = value
        } else {
          this.massUpdateForm.categories.push({
            category,
            value
          })
        }
        this.massUpdateAllowPercentage()
      },
      massUpdateAllowPercentage: function () {
        const percentage = this.massUpdateForm.categories.reduce((acc, item) => {
          acc += Number(item.value)
          return acc
        }, 0)
        return percentage
      },
      saveMassUpdate: function () {
        if (!this.massUpdateForm.clinics) {
          this.$store.dispatch('showAlert', {
            text: 'Please select clinic to update',
            type: 'error'
          })
          return
        }
        this.tableData = this.tableData.map(category => {
          this.massUpdateForm.categories.map(mCategory => {
            if (category.title === mCategory.category) {
              category.clinics.map(clinic => {
                const isSelectedClinic = this.massUpdateForm.clinics.find(item => item === clinic.id)
                if (isSelectedClinic) {
                  clinic.percentage = mCategory.value ? mCategory.value : clinic.percentage
                }
                return clinic
              })
            }
          })
          return category
        })
        this.isMassUpdate = false
      },
      editorHandler: function (value, category, clinic) {
        if (this.sendRequestLoading || this.isMassUpdate) {
          return null
        }
        this.touched = true
        if (this.inputFormData.clinicId && this.inputFormData.category) {
          const clinicOld = this.tableData.find(
            category => category.title === this.inputFormData.category
          ).clinics.find(
            clinic => clinic.id === this.inputFormData.clinicId
          )
          clinicOld.editor = !this.inputFormData.isOpen
        }
        if (clinic) {
          clinic.editor = value
          this.inputFormData.isOpen = value
        }
        this.inputFormData.clinicId = clinic ? clinic.id : null
        this.inputFormData.category = category ? category.title : null
        this.inputFormData.percentage = clinic ? clinic.percentage : null
      },
      percentageHandler: function () {
        if (this.inputFormData.percentage) {
          this.tableData = this.tableData.map(category => {
            if (category.title === this.inputFormData.category) {
              category.clinics = category.clinics.map(clinic => {
                if (clinic.id === this.inputFormData.clinicId) {
                  clinic.percentage = this.inputFormData.percentage
                }
                return { ...clinic }
              })
            }
            return category
          })
          this.editorHandler()
        }
      },
      sendForm: async function () {
        this.editorHandler()
        this.sendRequestLoading = true
        const results = this.headers.map(({ id }) => ({
          clinicId: id,
          categories: []
        }))
        results.map(res => {
          this.tableData.map(category => {
            category.clinics.map(clinic => {
              if (clinic.id === res.clinicId) {
                res.categories.push({
                  title: category.title,
                  percentage: clinic.percentage
                })
              }
              return clinic
            })
          })
          return results
        })
        await this.$store.dispatch('editAccountingBudget', {
          clinicsSettings: results,
          groupId: this.$store.getters.getUserActiveGroup,
          date: this.month
        })
        this.touched = false
        this.sendRequestLoading = false
      },
      percentageLeftValue: function (clinicId) {
        return this.tableData.reduce((acc, category) => {
          category.clinics.map(clinic => {
            if (clinic.id === clinicId) {
              acc += Number(clinic.percentage)
            }
          })
          return acc
        }, 0)
      },
      cancelBudgetEdit: async function () {
        if (this.touched) {
          const confirmModalOptions = {
            text: 'Do you want to go back without save?',
            agreeBtnText: 'Yes',
            type: 'info'
          }
          const confirm = await this.$root.$confirmDialog.open('', confirmModalOptions)
          if (!confirm) {
            return null
          }
        }
        await this.$router.push('/accounting')
      },
      reloadData: async function () {
        try {
          this.loading = true

          const response = await this.$store.dispatch('fetchAccountingBudget', {
            date: this.month
          })

          this.tableData = response.data.categorySettings.map(category => {
            category.clinics = category.clinics.map(clinic => {
              return {
                ...clinic,
                editor: false
              }
            })
            return category
          })
          this.headers = this.tableData.reduce((acc, item) => {
            item.clinics.map(clinic => {
              if (!acc.find(added => added.id === clinic.id) || !acc.length) {
                acc.push(clinic)
              }
            })
            return acc
          }, [])
        } catch (e) {
          this.tokenMissed = true
        }

        this.loading = false
      }
    },
    async mounted () {
      await this.reloadData()
    }
  }
</script>
<style lang="scss" scoped>
    .sticky-column {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 2;
      background-color: white;
    }
    .sticky-column-header{
      z-index: 3;
    }
    .table-bordered {
        table {
            border-collapse: collapse !important;
            td {
                height: 50px;
                border-collapse: collapse;
                padding-left: 0px;
                padding-right: 0px;
                border-left: thin solid rgba(0, 0, 0, .12) !important;
                &:nth-child(2){
                  border-left: 0 !important;
                }
                &:first-child {
                    min-width: 250px;
                    padding: 0 10px;
                    position: sticky;
                    left: 0;
                    border-right: thin solid rgba(0, 0, 0, .12) !important;
                }

                &:last-child {
                    border-right: thin solid rgba(0, 0, 0, .12) !important;
                }
            }

            tr {
                border-left: 0;

                &:hover {
                    background-color: lighten(#ececec, 10%) !important;
                }

                &.expanded-content {
                    background-color: #f8f8f8;
                }

                &.expandable-tr {
                    cursor: pointer;
                    background-color: #fff;
                    font-weight: bold;

                    &:hover {
                        background-color: darken(#F3F7EF, 5%) !important;
                    }

                    &.disabled-tr {
                        opacity: 0.5;
                    }

                    &.expanded {
                        background-color: #F3F7EF;
                        color: #6c9d39;
                    }

                    td {
                        border-top: 1px solid #7d7c7c !important;
                    }
                }
            }

            thead {

                th {
                    border-left: 0;
                    padding-left: 10px;
                    padding-right: 10px;
                    color: #000;
                }

                tr {
                    transition: all .3s;
                    th {
                        height: 20px;
                        padding-top: 0;
                        padding-bottom: 0;
                    }

                    &:first-child {
                        th {
                            padding: 5px !important;
                            height: 20px;
                        }
                    }

                    &:last-child {
                        th {
                            border-bottom: 0;
                        }
                    }
                }
            }
        }
    }

    .shake-animation {
        animation: shake 1s linear;
    }

    @keyframes shake {
        0%, 100% {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        10%, 30%, 50%, 70%, 90% {
            -webkit-transform: translate3d(-10px, 0, 0);
            transform: translate3d(-10px, 0, 0);
        }

        20%, 40%, 60%, 80% {
            -webkit-transform: translate3d(10px, 0, 0);
            transform: translate3d(10px, 0, 0);
        }
    }

    .custom-years-title {
        font-size: 20px !important;
        border-bottom: 2px solid rgba(0, 0, 0, 0.87);
        padding-bottom: 5px;
        margin: 0 42px;
    }

    .inputInsideTable {
        padding: 0 30px;
        max-width: 300px;
        margin-bottom: -15px;
    }

    .percentage-left {
        text-align: center;
        margin-top: 10px;
    }

    .inputMassUpdate {
        width: 60px;
        margin: 0 auto;
    }

    .monthField {
      max-width: 150px;
    }
</style>
